import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { updateDocumentStatus, insertDraftEmail } from "../services/adminDocuments_service";
import QueueEmailModal from "./modals/QueueEmailModal";
import CustomDraftModal from "./modals/CustomDraftModal";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../../../store/authStore";

const DocumentsActionsPanel = ({ selectedRows, reloadGrid }) => {

  const disabled = selectedRows.length === 0;
  const navigate = useNavigate();

  const userid = useAuthStore((state)=> state.user)

  const [showQueueModal, setShowQueueModal] = useState(false);
  const [queuePayload, setQueuePayload] = useState(null);
  const [showCustomDraftModal,setShowCustomDraftModal] = useState(false);
  const [disableQueueButton, setDisableQueueButton] = useState(true)
  const [disablePrepareButton, setDisablePrepareButton] = useState(true);
  const [disableDraftButton, setDisableDraftButton] = useState(true);

  const handleUpdateDocumentStatus = async (status) => {

    const statusId =
      status === "Published"
        ? 1
        : status === "UnPublished"
        ? 2
        : 3;

    try {

      const docIDs = selectedRows
        .map((item) => item.documentId)
        .join(",");

      const row = selectedRows[0];

      const payload = {
        ...row,
        documentWebStatusId: statusId,
        documentWebStatusName: status,
        documentIds: docIDs
      };

      await updateDocumentStatus(payload);

      toast.success(`Documents ${status} successfully.`);

      if (reloadGrid) reloadGrid();

    }
    catch {

      toast.error("Unable to update document status.");

    }

  };

  const handleQueueEmail = () => {

    const docIds = selectedRows
      .map((r) => r.documentId)
      .join(",");

    let emailTemplateIds = [];
    let documentTypeId = null;

    for (const item of selectedRows) {

      if (item.documentTypeName === "Billing") {
        documentTypeId = 4;
      }

      if (
        item.documentTypeName === "Billing" &&
        !emailTemplateIds.includes(item.emailTemplateId)
      ) {
        emailTemplateIds.push(item.emailTemplateId);
      }

    }

    if (emailTemplateIds.length > 1) {

      toast.error(
        "More than one email templates were found. All selected documents must use the same email template."
      );

      return;

    }

    const alreadyEmailed = selectedRows.filter(
      (x) => x.emailStatus !== null && x.emailStatus !== ""
    );

    if (alreadyEmailed.length > 0) {

      toast.error(
        "Document already emailed, please review the selection."
      );

      return;

    }

    const payload = {
      docIds,
      userId: userid,
      documentTypeId,
      emailTemplateId: emailTemplateIds[0]
    };

    setQueuePayload(payload);
    setShowQueueModal(true);

  };

  const handlePrepareEmail = async () => {

  try {

    const docIds = selectedRows
      .map((item) => item.documentId)
      .join(",");

    const alreadyEmailed = selectedRows.filter(
      (x) => x.emailStatus !== null && x.emailStatus !== ""
    );

    if (alreadyEmailed.length > 0) {

      toast.error(
        "Document already emailed, please review the selection"
      );

      return;

    }

    const userId = userid; // same behavior as your other functions

    const response = await insertDraftEmail(
      docIds,
      null,
      userId
    );

    const returnedEmailId = response.data;

    if (returnedEmailId === -5) {

      toast.error(
        "No recipients found. Draft not added"
      );

      return;

    }
    else if (returnedEmailId === -6){
      toast.error("No default template found. Draft not Added")
      return;
    }

    navigate('/Email', {state:{returnedEmail: returnedEmailId, selectedTab: 'draft'}})

    // const param1 = encryptString("EmailDraftAdmin");
    // const param2 = encryptString(returnedEmailId);

    // let url = "/Email";

    // if (param1 && param2) {

    //   url = `/Email?param1=${param1}&param2=${param2}`;

    // }

    // window.location.href = url;

  }
  catch {

    toast.error("Unable to prepare email.");

  }

};

useEffect(() => {

  // When nothing is selected → disable everything
  if (!selectedRows || selectedRows.length === 0) {
    setDisableQueueButton(true);
    setDisablePrepareButton(true);
    setDisableDraftButton(true);
    return;
  }

  let listHasBillingDocType = false;
  let listHasOtherDocsTypes = false;
  let listHasUnpublishedDocs = false;
  let hasEmailsSent = false;

  selectedRows.forEach((item) => {

    if (item.documentTypeName === "Billing")
      listHasBillingDocType = true;
    else
      listHasOtherDocsTypes = true;

    if (item.documentWebStatusId === 2)
      listHasUnpublishedDocs = true;

    if (item.emailStatus === "Sent" || item.emailStatus === "Scheduled")
      hasEmailsSent = true;

  });

  // === Equivalent of CanAddDocumentToList ===
  const canQueueEmail = !(
    (listHasBillingDocType && listHasOtherDocsTypes) ||
    listHasUnpublishedDocs ||
    hasEmailsSent
  );

  // === Equivalent of CanPrepareEmail ===
  const canPrepareEmail = !(
    listHasBillingDocType ||
    listHasUnpublishedDocs ||
    hasEmailsSent
  );

  // Apply states (note: disabled = inverse)
  setDisableQueueButton(!canQueueEmail);
  setDisablePrepareButton(!canPrepareEmail);

  // Draft button is disabled in BOTH original functions
  // so it should be disabled if either action is not allowed
  setDisableDraftButton(!(canQueueEmail && canPrepareEmail));

}, [selectedRows]);



  return (
    <>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginTop: "10px",
          marginBottom: "10px"
        }}
      >

        <span style={{ color: "#00609e" }}>
          With Selected:
        </span>

        <button
          className="btn btn-primary"
          disabled={disabled}
          onClick={() => handleUpdateDocumentStatus("Published")}
        >
          Publish
        </button>

        <button
          className="btn btn-primary"
          disabled={disabled}
          onClick={() => handleUpdateDocumentStatus("UnPublished")}
        >
          UnPublish
        </button>

        <button
          className="btn btn-primary"
          disabled={disabled}
          onClick={() => handleUpdateDocumentStatus("Deleted")}
        >
          Delete
        </button>

        <button
          className="btn btn-primary"
          disabled={disableQueueButton}
          onClick={handleQueueEmail}
        >
          Queue Email
        </button>

        <button className="btn btn-primary" disabled={disablePrepareButton} onClick={handlePrepareEmail}>
          Prepare Email
        </button>

        <button
          className="btn btn-primary"
          disabled={disableDraftButton}
          onClick={()=>setShowCustomDraftModal(true)}
        >
          Custom Draft
        </button>

      </div>

      {showQueueModal && (

        <QueueEmailModal
          show={showQueueModal}
          payload={queuePayload}
          reloadGrid={reloadGrid}
          onClose={() => setShowQueueModal(false)}
        />

      )}

      {showCustomDraftModal && (

  <CustomDraftModal
    show={showCustomDraftModal}
    selectedRows={selectedRows}
    onClose={()=>setShowCustomDraftModal(false)}
  />

)}

    </>
  );
};

export default DocumentsActionsPanel;